import { Button } from 'component/Button'
import { Link } from 'component/Link'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { Page } from 'page/Page/Page'
import { MouseEvent } from 'react'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const Policy = () => {
  const textKey = opt.atelier ? 'PolicyTextAtelier' : 'PolicyText'

  const onClick = useLatestCallback((event: MouseEvent) => {
    const url = event.currentTarget.getAttribute('href') || ''
    if (!url) return

    if (opt.stand) store.doc = url
    else window.open(url, '_blank')
  })

  const onAccept = useLatestCallback(async () => {
    await controller.acceptPolicy()
  })

  return (
    <Page clear center>
      <Vertical maxWidth={480} center>
        <Vertical gap={40} center>
          <Icon name="privacy_tip" size={24} />
          <Vertical gap={16} center>
            <Space maxWidth={200} center>
              <Typo size={17} center accent upper letter={1.2}>
                {i18n('PolicyTitle')}
              </Typo>
            </Space>
            <Typo size={15} center secondary balance>
              {i18n(textKey, { Link: <Link wrap underline action={onClick} /> })}
            </Typo>
          </Vertical>
          <Button large primary action={onAccept}>
            {i18n('Continue')}
          </Button>
        </Vertical>
      </Vertical>
    </Page>
  )
}
